import { useSyncExternalStore } from 'react';

/**
 * @param {number} maxPx
 * @returns {boolean} true when viewport width ≤ maxPx
 */
export function useMaxWidth(maxPx) {
  const query = `(max-width: ${maxPx}px)`;
  return useSyncExternalStore(
    (onChange) => {
      if (typeof window === 'undefined') return () => {};
      const mq = window.matchMedia(query);
      mq.addEventListener('change', onChange);
      return () => mq.removeEventListener('change', onChange);
    },
    () => (typeof window !== 'undefined' ? window.matchMedia(query).matches : false),
    () => false,
  );
}
